import React from "react";
import { SplitsReportPage } from "./splits-report-page";

export const HittingSplitsReportPage = () => <SplitsReportPage kind="batter" />;
